import { registerWebserverToken } from '../shared/xomics-webserver-client';

const STORAGE_KEY = 'familyrisk_cookie';

function getStoredApiKey() {
  return localStorage.getItem(STORAGE_KEY);
}

function setStoredApiKey(key) {
  localStorage.setItem(STORAGE_KEY, key);
}

function generateUUID() {
  return crypto.randomUUID();
}

export async function ensureFamilyRiskApiKey() {
  let apiKey = getStoredApiKey();

  if (!apiKey) {
    apiKey = generateUUID();
    setStoredApiKey(apiKey);
  }

  await registerWebserverToken(apiKey);
  return apiKey;
}

export function getAuthHeaders() {
  const apiKey = getStoredApiKey();
  if (!apiKey) throw new Error('A FamilyRisk Webserver credential is required');
  return {
    'Content-Type': 'application/json',
    'X-Webserver-Token': apiKey,
  };
}
